import firebase from 'firebase/compat/app';
import { MobileApiClient, Product } from 'hydra-data-types';
import { Environment } from '../helpers/Environment';
import { functionsModule } from '../helpers/firebase/FirebaseFunctions';

// Use locally running emulator as Firebase Functions host. The emulator can be started by running 'yarn serve' in
// /functions (within the hydra-mobile codebase)
const USE_LOCAL_FUNCTIONS = !Environment.isProduction() && false;

type Options = firebase.functions.HttpsCallableOptions;
type Result = firebase.functions.HttpsCallableResult;

export class ApiClientNerva extends MobileApiClient<Options, Result> {
  constructor() {
    super({
      functions: functionsModule(),
      baseData: {
        product: Product.Nerva,
      },
      options: {
        useEmulator: USE_LOCAL_FUNCTIONS,
      },
    });
  }
}
